<template>
    <Modal name="removeSchedule" v-bind="$attrs" :key='id'>
        <template v-slot:header>
            <h1>{{ $t('remove_schedule') }}</h1>
        </template>
        <template v-slot:body>
            <div class="row">
                <div class="label-wrapper name">
                    <feather size="20px" stroke-width="1" type="type" />
                    <label>{{ $t('enter_schedule_name_to_confirm_removal') }}: <span class="bg-gray-100 rounded p-2 mx-1 italic font-bold">{{ $attrs.name }}</span></label>
                </div>
                <p class="error_text">{{ $t('caution_removing_schedule') }}</p>
                <div class="form">
                    <input ref="name" type="text" name="name" v-model="name" maxlength="100" required />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="btn btn-primary submit" :class="name != $attrs.name ? 'disabled' : ''" @click="submit">
                <feather size="24px" type="send" /> {{ $t('remove') }}
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '../modules/modals/components/Modal'
import { mapActions } from 'vuex'

export default {
    name: 'modalRemoveSchedule',
    components: {
        Modal
    },
    data(){
        return {
            name: '',
            id: null,
        }
    },
    methods: {
        ...mapActions({
            deleteSchedule: 'deleteSchedule',
        }),
        submit(){
            if(this.name == this.$attrs.name){
                this.deleteSchedule(this.$attrs.id)
                this.$attrs.close()
            }
        },
    },
    mounted(){

    }
}
</script>

<style lang="sass" scoped>
label
    font-weight: 700
    font-size: 17px
input, select, textarea
    border: 1px solid #F0F1F3!important
    border-radius: 7px
    width: 100%
input[type='checkbox']
    min-width: 25px
    width: inherit
    height: 25px
.label-wrapper
    display: flex
    align-items: center
    margin-bottom: 4px
    label
        margin-left: 10px
.row
    .col
        flex: 1
    &:not(:last-child)
        margin-bottom: 1.5rem
    .form
        padding-left: 30px
.error_text
    color: #CC0000
    padding: 20px
</style>
